export default {
  PARENT: 'parent',
  PLAYER: 'player',
}
